var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header-bar',{staticClass:"header-bar-component"}),_c('router-view'),_c('footer-bar',{staticClass:"footer-bar-component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }